import { requestApi } from 'api/api'
import {
  BulkCapabilityRequest,
  BulkCapabilityResponse,
} from 'types/capabilities/capabilities'

export const getBulkCapabilityValues = (
  request: BulkCapabilityRequest
): Promise<BulkCapabilityResponse> => {
  return requestApi({
    baseUrl: process.env.API_URL,
    url: '/governance/v1/capabilities/bulk',
    method: 'POST',
    data: request,
  })
}
